<ng-container
  *ngIf="{
    isNonPartnerAutomation: (isNonPartnerAutomation$ | async),
  } as data"
>
  <div class="content">
    <div class="description subtitle">
      {{ 'AUTOMATIONS.EDITOR.TASKS.CHANGE_OPPORTUNITY_PIPELINE_STAGE.UPDATE_DESCRIPTION' | translate }}
    </div>

    <automata-pipeline-selector
      #pipelineSelector
      [required]="!data.isNonPartnerAutomation"
      [selectedPipelineId]="initialPipelineId"
      [selectedStageId]="initialStageId"
      (loaded)="pipelineSelectorLoaded()"
    ></automata-pipeline-selector>
  </div>
</ng-container>
